<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 昵称管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between">
          <div style="display: flex; align-items: center">
            <span style="margin-left: 20px; margin-right: 10px; font-size: 15px">昵称：</span>
            <el-input v-model="listQuery.nickname" placeholder="请输入昵称" style="width: 220px"></el-input>
          </div>

          <div style="margin-right: 20px">
            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="success" @click="handleCreate">添加</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="warning" @click="resetAll">重置</el-button>
          </div>
        </div>

        <el-table border v-loading="listLoading" min-height="200" max-height="1000" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" width="120" />
          <el-table-column prop="nickname" label="昵称" />
          <el-table-column label="操作" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="operationButton" type="primary" size="mini" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
              <el-button v-if="operationButton" type="danger" size="mini" @click="userDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

        <el-dialog title="删除" center width="30%" :visible.sync="deleteShow">
          <p>确认删除该昵称吗？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="deleteShow = false">取 消</el-button>
            <el-button type="primary" @click="handleDelete">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog :title="formData.id ? '编辑昵称' : '新增昵称'" center width="35%" :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="margin-left: 20px">
            <el-form-item label="昵称" :label-width="formLabelWidth">
              <el-col :span="16">
                <el-input v-model="formData.nickname" maxlength="100"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/index';
import { getNormalNicknameListApi, saveNormalNicknameApi, deleteNormalNicknameApi } from '@/api/normal_nickname';

export default {
  name: 'nicknameManage',
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        nickname: '',
        page: 1,
        limit: 10,
      },
      operationButton: true,
      dialogFormVisible: false,
      deleteShow: false,
      delID: '',
      formData: {
        id: '',
        nickname: '',
      },
      formLabelWidth: '100px',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      getNormalNicknameListApi(this.listQuery)
        .then((response) => {
          const payload = response.data.data || {};
          this.tableData = payload.data || [];
          this.total = Number(payload.total || 0);
          this.listQuery.page = Number(payload.current_page || this.listQuery.page);
          this.operationButton = payload.operation_button !== false;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetAll() {
      this.listQuery.nickname = '';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    handleCreate() {
      this.formData.id = '';
      this.formData.nickname = '';
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      this.formData.id = row.id;
      this.formData.nickname = row.nickname;
      this.dialogFormVisible = true;
    },
    handleSave() {
      if (!this.formData.nickname || !this.formData.nickname.trim()) {
        this.$message.warning('请输入昵称');
        return;
      }
      const data = {
        nickname: this.formData.nickname.trim(),
      };
      if (this.formData.id) {
        data.id = this.formData.id;
      }
      saveNormalNicknameApi(data)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message || 'success');
            this.dialogFormVisible = false;
            this.getList();
          } else {
            this.$message.error(response.data.message || '保存失败');
          }
        })
        .catch(() => {});
    },
    userDelete(row) {
      this.delID = row.id;
      this.deleteShow = true;
    },
    handleDelete() {
      deleteNormalNicknameApi(this.delID)
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message || 'success');
            this.deleteShow = false;
            this.getList();
          } else {
            this.$message.error(response.data.message || '删除失败');
            this.deleteShow = false;
          }
        })
        .catch(() => {});
    },
  },
};
</script>
